import React from 'react';
import './CssEditor.scss';
import CodeMirror from '@uiw/react-codemirror';
import 'codemirror/keymap/sublime';
import 'codemirror/theme/elegant.css';
import 'codemirror/addon/hint/show-hint.js';
import 'codemirror/addon/hint/css-hint.js';
import 'codemirror/addon/hint/show-hint.css';
const CssEditor = ({
  value,
  onChange
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "css-editor"
  }, /*#__PURE__*/React.createElement(CodeMirror, {
    value: value,
    height: "200px",
    onChange: onChange,
    options: {
      theme: 'elegant',
      keyMap: 'sublime',
      mode: 'css',
      lineNumbers: false,
      extraKeys: {
        'Ctrl-Space': 'autocomplete'
      }
    }
  }));
};
export default CssEditor;